import { render, staticRenderFns } from "./MarketCategory.vue?vue&type=template&id=2b990c80&scoped=true&"
import script from "./MarketCategory.vue?vue&type=script&lang=js&"
export * from "./MarketCategory.vue?vue&type=script&lang=js&"
import style0 from "./MarketCategory.vue?vue&type=style&index=0&id=2b990c80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b990c80",
  null
  
)

export default component.exports